import { render } from "./ViewAllReviewPosts.vue?vue&type=template&id=51423a74"
import script from "./ViewAllReviewPosts.vue?vue&type=script&lang=js"
export * from "./ViewAllReviewPosts.vue?vue&type=script&lang=js"

import exportComponent from "/data/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__